import {WorkRolesProjectsList} from "./WorkRolesProjectsList";
import {WorkRolesProjectsEdit} from "./WorkRolesProjectsEdit";
import {WorkRolesProjectsCreate} from "./WorkRolesProjectsCreate";

export default {
    list: WorkRolesProjectsList,
    create: WorkRolesProjectsCreate,
    edit: WorkRolesProjectsEdit
};
